import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import { forwardRef, useEffect, useRef, useState } from 'react';
import BaseImage from '../base-image';
type RotatedImageProps = {
  alt: string;
  src: string;
  rotateIndex: number;
};
const RotatedImage = forwardRef<HTMLDivElement, RotatedImageProps>((t0, ref) => {
  const $ = _c(24);
  const {
    alt,
    src,
    rotateIndex
  } = t0;
  const imageRef = useRef(null);
  const [aspectRatio, setAspectRatio] = useState("auto");
  let t1;
  let t2;
  if ($[0] !== rotateIndex || $[1] !== src) {
    t1 = () => {
      if (rotateIndex === 0) {
        const img = new Image();
        img.onload = () => {
          const aspectRatio_0 = img.width / img.height;
          setAspectRatio(aspectRatio_0);
        };
        img.src = src;
      }
    };
    t2 = [src, rotateIndex];
    $[0] = rotateIndex;
    $[1] = src;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== rotateIndex) {
    t3 = () => {
      if (rotateIndex === 0) {
        return "";
      }
      const translateClass = rotateIndex % 2 === 0 ? "-translate-x-0.5" : "translate-x-0.5";
      const translateYClass = `translate-y-[${rotateIndex * 3}px]`;
      const rotateClass = rotateIndex % 2 === 0 ? "-rotate-2" : "rotate-2";
      return `${translateClass} ${translateYClass} ${rotateClass}`;
    };
    $[4] = rotateIndex;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const getTransformClasses = t3;
  let t4;
  if ($[6] !== rotateIndex) {
    t4 = () => `z-[${20 - rotateIndex}]`;
    $[6] = rotateIndex;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const getZIndexClass = t4;
  let t5;
  if ($[8] !== getTransformClasses || $[9] !== getZIndexClass) {
    t5 = cx("absolute top-0 left-0 w-full", getTransformClasses(), getZIndexClass());
    $[8] = getTransformClasses;
    $[9] = getZIndexClass;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== alt || $[12] !== src) {
    t6 = <BaseImage alt={alt} src={src} ref={imageRef} />;
    $[11] = alt;
    $[12] = src;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== ref || $[15] !== t5 || $[16] !== t6) {
    t7 = <div ref={ref} className={t5}>{t6}</div>;
    $[14] = ref;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== aspectRatio || $[19] !== rotateIndex) {
    t8 = rotateIndex === 0 && <div className="invisible w-full h-auto" style={{
      aspectRatio
    }} />;
    $[18] = aspectRatio;
    $[19] = rotateIndex;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t7 || $[22] !== t8) {
    t9 = <>{t7}{t8}</>;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
});
export default RotatedImage;